// src/App.jsx
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Consultation from './pages/Consultation'
import Properties from './pages/Properties'
import Media from './pages/Media'
import Contact from './pages/Contact'
import Careers from './pages/Careers'
import Insights from './pages/Insights'
import CSR from './pages/CSR'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <NavBar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/consultation" element={<Consultation />} />
            <Route path="/services/properties" element={<Properties />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/media" element={<Media />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/csr" element={<CSR />} />
            
            {/* Optional: 404 Page */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

// Simple 404 component
const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h1 className="text-9xl font-bold text-ofanda-yellow">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900 font-playfair">
            Page Not Found
          </h2>
          <p className="mt-4 text-gray-600">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </div>
        <div className="space-y-4">
          <a
            href="/"
            className="w-full bg-ofanda-yellow text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition-colors duration-300 inline-block"
          >
            Go back home
          </a>
          <a
            href="/contact"
            className="w-full border-2 border-ofanda-yellow text-ofanda-yellow px-6 py-3 rounded-lg font-semibold hover:bg-ofanda-yellow hover:text-gray-900 transition-colors duration-300 inline-block"
          >
            Contact support
          </a>
        </div>
      </div>
    </div>
  )
}

export default App